import styled from 'styled-components'

import fechar from '../../assets/images/close.png'

import { colors } from '../../styles'
import { TagContainer } from '../Tag/styles'
import { ButtonContainer } from '../Button/styles'

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`

export const CartContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  z-index: 1;

  &.is-open {
    display: flex;
    justify-content: flex-end;
  }
`

export const Sidebar = styled.aside`
  background-color: ${colors.secondaryBackground};
  z-index: 1;
  padding: 40px 16px 0 16px;
  max-width: 360px;
  width: 100%;

  ${ButtonContainer} {
    cursor: pointer;
    max-width: 100%;
    width: 100%;
  }

  .empty-cart-text {
    font-size: 14px;
    line-height: 22px;
    color: ${colors.text};
    text-align: center;
  }
`

export const Prices = styled.p`
  font-weight: bold;
  font-size: 14px;
  color: ${colors.text};
  margin-bottom: 24px;

  span {
    display: block;
    font-size: 12px;
    color: ${colors.footerText};
  }
`

export const Quantity = styled.p`
  font-weight: bold;
  font-size: 16px;
  color: ${colors.text};
  margin: 32px 0 16px;
`

export const CartItem = styled.li`
  display: flex;
  border-bottom: 1px solid ${colors.footerText};
  padding: 8px 0;
  position: relative;

  img {
    height: 80px;
    width: 80px;
    object-fit: cover;
    margin-right: 24px;
  }

  h3 {
    font-size: 16px;
    font-weight: bold;
    color: ${colors.text};
  }

  span {
    display: block;
    font-size: 14px;
  }

  h3,
  span {
    font-weight: bold;
    color: ${colors.text};
  }

  ${TagContainer} {
    margin-right: 8px;
    margin-top: 8px;
    margin-bottom: 16px;
  }

  button {
    background-image: url(${fechar});
    width: 16px;
    height: 16px;
    border: none;
    background-color: transparent;
    position: absolute;
    top: 8px;
    right: 0;
    cursor: pointer;
  }
`
